import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {Observable, of as observableOf} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';

import * as cultivosActions from './cultivos.actions';
import {CultivosService} from "../../../../../chacra-core/services/cultivos.service";

@Injectable()
export class CultivosEffects {
  CultivosLoadRequestEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<cultivosActions.CultivosLoadRequestAction>(
      cultivosActions.CultivosActionTypes.CULTIVOS_LOAD_REQUEST
    ),
    switchMap(() => {
      return this.cultivosService.get().pipe(
        map(queryResults => {
          return new cultivosActions.CultivosLoadSuccessAction({
            items: queryResults.items
          });
        }),
        catchError(error =>
          observableOf(
            new cultivosActions.CultivosLoadFailureAction({
              error
            })
          )
        )
      );
    })
  ));

  // load

  constructor(
    private cultivosService: CultivosService,
    private actions$: Actions
  ) {
  }
}
